;(function() {
  'use strict'

  Directive.$inject = ["chainService"];
  angular.module('app.page').directive('moduleFeedback', Directive)

  /* @ngInject */
  function Directive(chainService) {
    controller.$inject = ["$scope", "messageService"];
    return {
      restrict: 'E',
      scope: {
        page: '=',
        module: '=',
      },
      templateUrl: 'module-feedback.template.html',
      link: link,
      controller: controller,
    }

    function link(scope, elem) {
      elem.addClass('module-feedback')
    }

    /* @ngInject */
    function controller($scope, messageService) {
      $scope.showDialog = showDialog

      function showDialog() {
        // TODO
        // implement this when referral chains are specced
        // will probably need to clone and refactor the current message dialog as it is vastly different
        // Doug: "I think the idea is you'll have an element Id and you'll pass the page ID as part of the
        // referral chain"
        // Doug: "The chain part is working - We're adding 'X-Glow-Referral-Chain' header to requests"
        // UPDATE: creating a post for an element with the link/page as metadata
        // if element is unknown, we change post subject: { type: 'page', id: pageId }

        chainService.update({ moduleId: $scope.module.id })

        messageService.showSendDialog({
          pageId: $scope.page.id,
        })
      }
    }
  }
})()
